define.alias("shared/components/shared/social-identity/placeholder-item", "calendar/components/shared/social-identity/placeholder-item");